<template>
<div id="adjuntar_edocuments">
  <div>
    <v-breadcrumbs :items="breadcrumbs">
      <v-icon slot="divider">forward</v-icon>
    </v-breadcrumbs>
  </div>
  <v-container fluid fill-height>
    <v-row align-center justify-center>

      <v-col xs12>
        
        <base-material-card color="primary" icon="library_books" title="Adjuntar PDF a eDocuments y Acuses de Pedimentos" class="elevation-1 px-5 py-3">

          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
          <v-card-text>
            <v-card-text>
              <v-form ref="form_buscar" lazy-validation>
                <v-container grid-list-md>
                  <v-row wrap>
                    <v-col sm="9">
                      <v-text-field label="Buscar eDocument" v-model='search' 
                        v-on:keydown.enter.prevent='1'
                        @keydown.enter="buscar"
                        @input="search = search.toString().toUpperCase()"
                        :rules="[rules.required]" prepend-icon='search'></v-text-field>
                    </v-col>
                    <v-col sm="3">
                      <v-btn @click.native="buscar">
                        <v-icon>search</v-icon> Buscar
                      </v-btn>
                      <v-btn color="green" @click.native="verifica_archivos_seleccionados" v-if="to_upload.length > 0">
                        <v-icon>save</v-icon> Adjuntar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
              <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2 scroll-table">
                <template slot="noResults">
                  <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                </template>
              
                <template slot="id" slot-scope="props">
                  <div style="display:flex; justify-content:center;">
                    <input :id="props.row.id" type="checkbox" v-model="to_upload" :value="props.row.id"></input>
                  </div>
                </template>                
              </v-client-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>

            </v-card-actions>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;">
      <v-card>
        <v-card-title>
          <v-card class="primary white--text titulomodal">
            <v-icon @click.native="modal = false" class="white--text">cancel</v-icon>&nbsp;
            <span class="subheading">
              <strong>Adjuntar PDF {{model.tipo_archivo}}</strong>
            </span>
          </v-card>
        </v-card-title>
        <v-card-text>
          <v-form ref="form_adjuntar" lazy-validation>
            <v-container grid-list-md>
              <!-- <v-row wrap>
                <v-col sm="12">
                  <v-autocomplete v-model="model.tipo_documento" :items="tipos_documento" :hide-no-data="true" :hide-selected="true" :return-object="false" item-text="nombre_completo" item-value="clave" label="Seleccione Tipo Documento"
                    :rules="[rules.required]">
                  </v-autocomplete>
                </v-col>
              </v-row> -->
              <v-row wrap>
                <v-col sm="12">
                  <file-pond allowPaste=false name="edoc" ref="pond" required class-name="my-pond" labelIdle="<span class='filepond--label-action'> Arrastre o seleccione su archivo .pdf   Aqui </span>" labelInvalidField="Archivo no valido"
                    labelFileWaitingForSize="Calculando el tamaño" labelFileSizeNotAvailable="Tamaño no valido" labelFileLoading="Cargando.." labelFileLoadError="Error al cargar" labelFileProcessing="Subiendo"
                    labelFileProcessingComplete="Carga completa" labelFileProcessingAborted="Carga cancelada" labelFileProcessingError="Error durante la carga" labelFileProcessingRevertError="Error" labelFileRemoveError="Error al eliminar"
                    labelTapToCancel="Cancelar" labelTapToRetry="Reintentar" labelTapToUndo="Deshacer" labelButtonRemoveItem="Eliminar" labelButtonAbortItemLoad="Abortar" labelButtonRetryItemLoad="Reintentar" labelButtonAbortItemProcessing="Cancelar"
                    labelButtonUndoItemProcessing="Deshacer" labelButtonRetryItemProcessing="Reintentar" labelButtonProcessItem="Subir" accepted-file-types=".pdf" v-bind:files="file_pdf" v-bind:server="myServerCER" allowFileTypeValidation />
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="modal = false">
            <v-icon>cancel</v-icon>Cerrar
          </v-btn>
          <v-btn color="green" @click.native="guardar">
            <v-icon>save</v-icon>Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'

export default {
  created: function() {
    this.cliente = this.$local_storage.get("id_cliente");
  },
  data() {
    return {
      fab: false,
      items: [],
      tipos_documento: [],
      allChecked: false,
      file_pdf: [],
      to_upload: [],
      show_loading: false,
      breadcrumbs: [{
          text: "Inicio",
          disabled: false,
          to: "/home"
        },
        {
          text: "E-Drive",
          disabled: true,
          href: ""
        },
        {
          text: "Adjuntar eDocuments Pedimento",
          disabled: true,
          href: ""
        }
      ],
      title: "",
      modal: false,
      columns: [
        "id",
        "rfc",
        "no_pedimento",
        "anio",
        "archivo"
      ],
      options: {
        filterable: ['rfc', 'no_pedimento', 'anio', 'archivo'],
        sortable: ['no_pedimento', 'anio', 'archivo'],
        headings: {
          id: "",
          rfc: 'RFC',
          no_pedimento: 'No. Pedimento',
          anio: 'Año'
        }
      },
      update: false,
      file: "",
      cliente: "",
      name_file: "",
      size_file: 0,
      type_file: 'application/zip',

      rules: {
        required: v => !!v || "Este campo es requerido",
      },
      search: "",

      model: {
        filename: "",
        tipo_documento: "",
        file: "",
        tipo_archivo:"",
        pedimentos:[],
      },
      myServerCER: {
        process: (fieldName, file, metadata, load) => {
          let name = file.name;
          let flag = true;
          const fr = new FileReader();
          fr.readAsDataURL(file);
          fr.addEventListener('load', () => {
            this.model.file = fr.result; // archivo en base64
          });

          setTimeout(() => {
            load(Date.now());
          }, 5);
        },
        load: (source, load) => {
          fetch(source)
            .then(res => res.blob())
            .then(load);
        }
      },
    };
  },

  methods: {
    verifica_archivos_seleccionados: function(){
      var self = this;
      var filtro = this.items.filter(e => self.to_upload.includes(e.id) );
      var tipos_seleccionados = [];
      self.model.pedimentos = [];
      if(filtro.length>0){
        for(var k in filtro){
          var item = filtro[k];
          if(!self.model.pedimentos.includes(item.id_pedimento)){
            self.model.pedimentos.push(item.id_pedimento);
          }
          
          if(!tipos_seleccionados.includes(item.tipo)){
            tipos_seleccionados.push(item.tipo);
          }
        }
      }
      
      if(tipos_seleccionados.length > 1){ //SOLO PUEDEN SELECCIONAR DE UN TIPO acuse o edocument, pero no combinados
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Solo puede seleccionar eDocuments o Acuses, pero no ambos. Favor de verificar.",          
        });
      } else if(tipos_seleccionados.length == 1){
        self.model.tipo_archivo = tipos_seleccionados[0];
        self.modal = true;
      }
      
    },
    check_all: function() {
      let arr = this.allChecked ? this.items.map(row => row.id) : [];

      if (arr.length == 0) {
        this.to_upload = [];
      } else {
        for (var i = 0; i < arr.length; i++) {
          if (this.to_upload.includes(arr[i])) {
            continue;
          } else {
            this.to_upload.push(arr[i]);
          }
        }
      }
    },
    guardar: function() {
      if (this.model.file == null || this.model.file == '') {
        this.$swal({
          type: "error",
          title: "¡Operación no Permitida!",
          text: "Debe seleccionar un archivo PDF.",
        });
        return false;
      }
      if (!this.$refs.form_adjuntar.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        let rfc = this.$local_storage.get("rfc");

        if(this.model.tipo_archivo == "edocument") {
            let datos = {
                rfc: rfc,
                pedimentos: this.model.pedimentos,
                file: this.model.file,
                tipo_documento: this.model.tipo_documento,
                edocument: this.model.filename
              };
              //console.log("EDOCUMENT");
              //console.log(datos);
              
              let url = this.$hostname + "vucem/adjuntar_edocument/";
              axios.post(url, datos)
                .then(() => {
                  this.$swal({
                    type: "success",
                    title: "¡Operación Exitosa!",
                    text: "Los archivos se actualizaron correctamente.",
                    footer: ""
                  });                  
                })
                .catch(err => {
                  this.modal = false;
                  this.$root.$dialogLoader.hide();

                  this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al guardar el registro. Intente nuevamente.",
                    footer: ""
                  });
                })
                .then(() => {
                  this.to_upload = [];
                  this.model.pedimentos = [];
                  this.model.filename = "";
                  this.file_pdf = [];
                  this.model.file = "";
                  this.model.tipo_documento = "";
                  this.model.tipo_archivo = "";
                  this.modal = false;
                  this.$root.$dialogLoader.hide();
                  this.buscar();
                });
        } else if(this.model.tipo_archivo == "acuse"){
            let datos = {
              rfc: rfc,
              pedimentos: this.model.pedimentos,
              file: this.model.file,
              tipo_documento: this.model.tipo_documento,
              edocument: this.model.filename
            };
            //console.log("ACUSE");
            //console.log(datos);

            let url = this.$hostname + "vucem/adjuntar_acuse_edocument/";
            axios.post(url, datos)
              .then(() => {
                this.$swal({
                  type: "success",
                  title: "¡Operación Exitosa!",
                  text: "El registro se guardó correctamente.",
                  footer: ""
                });
                
              })
              .catch(err => {
                this.modal = false;
                this.$root.$dialogLoader.hide();

                this.$swal({
                  type: "error",
                  title: "¡Operación no Permitida!",
                  text: "Ocurrió un error al guardar el registro. Intente nuevamente.",
                  footer: ""
                });
              })
              .then(() => {
                  this.to_upload = [];
                  this.model.pedimentos = [];
                  this.model.filename = "";
                  this.file_pdf = [];
                  this.model.file = "";
                  this.model.tipo_documento = "";
                  this.model.tipo_archivo = "";
                  this.modal = false;
                  this.$root.$dialogLoader.hide();
                  this.buscar();
              });
        }

        
      }
    },
    buscar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      this.model.filename = this.search;
      this.model.tipo_documento = this.search.substring(1, 4);
      let rfc = this.$local_storage.get("rfc");
      if (this.search === null) {
        this.$root.$dialogLoader.hide();
        return false;
      }
      var data = {
        rfc: rfc,
        busqueda: this.search,
      };
      let url = this.$hostname + "vucem/buscar_edocuments/";      
      axios
        .post(url, data)
        .then(res => {
          var self = this;
          self.items = [];
          if (res.data.length > 0) {
            self.items = res.data;
          } else {
            this.$swal({
              type: "error",
              title: "No se encontraron resultados",
              text: this.search,
              footer: "No se encontró o ya está recuperado. Favor de Verificar."
            });
          }
          this.$root.$dialogLoader.hide();
        })
        .catch(err => {
          this.$root.$dialogLoader.hide();
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al consultar el archivo",
            footer: ""
          });
          console.log(err);
        });
    }
  }
};
</script>
